import * as Sentry from "@sentry/browser";

import { scrubBreadcrumb, scrubEvent } from "./sentryScrub";

Sentry.init({
    dsn: "https://public_key@ingest_host/0000000", // Use a dummy DSN that satisfies Sentry's DSN regex validation. The real DSN is injected on the server-side via the `tunnel`.
    integrations: [
        Sentry.reportingObserverIntegration(),
        Sentry.eventFiltersIntegration(),
        // PHI/BAA app: never capture console output as breadcrumbs. The scrub below
        // redacts URLs/query values, but a console message body isn't URL-shaped, so
        // console is disabled outright. Other breadcrumb types (dom/fetch/history/xhr)
        // stay on and are scrubbed by beforeBreadcrumb.
        Sentry.breadcrumbsIntegration({ console: false }),
    ],

    // PHI/BAA app: redact patient filter/search values out of fetch/xhr/navigation
    // breadcrumb URLs and event request URLs before anything leaves the browser
    // (the exam/user/scanner tables put patient_name/patient_msp/etc. into query
    // strings). Mirrors frontend/src/shared/sentryScrub.ts for the Vite apps.
    beforeBreadcrumb: scrubBreadcrumb,
    beforeSend: scrubEvent,
    beforeSendTransaction: scrubEvent,

    ignoreErrors: [
        // Google Charts (frozen since 2023) calls Intl.v8BreakIterator, deprecated in Chrome 148.
        "Intl.v8BreakIterator",
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^\//],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // https://docs.sentry.io/platforms/javascript/troubleshooting/#dealing-with-ad-blockers
    tunnel: "/tracetunnel/",
});

// PHI-safe client-issue reporter for the legacy bundle. Riot tags and other entries
// can't import the SDK without bundling a second copy of it, so they call this global
// instead. It takes ONLY a static message string (never an error object or value), so
// it cannot carry PHI to Sentry — use it to report a handled failure that developers
// should know about but that has no user-visible error path.
window.reportClientIssue = (message) => {
    try {
        // Delivered via the tunnel configured in init() above (/tracetunnel/), so it's
        // first-party and not blocked by ad-blockers. The send is async, so a failed or
        // blocked transport is handled inside the SDK — it never throws back here.
        Sentry.captureMessage(String(message), "warning");
    } catch (_e) {
        // Defensive only: this runs inside other catch blocks, so never let issue
        // reporting throw into the caller (e.g. if the SDK failed to initialise).
    }
};
